import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
  Link,
  Font,
} from "@react-pdf/renderer";

// import Roboto from "../../../fonts/Roboto-Regular.ttf";
// import RobotoBold from "../../../fonts/Roboto-Bold.ttf";
// import RobotoItalic from "../../../fonts/Roboto-Italic.ttf";
// import RobotoLight from "../../../fonts/Roboto-Light.ttf";
// import Poppins from "../../../fonts/Poppins-Regular.ttf";
// import PoppinsBold from "../../../fonts/Poppins-Bold.ttf";
// import PoppinsItalic from "../../../fonts/Poppins-Italic.ttf";

// Font.register({
//   family: "Roboto",
//   src: RobotoItalic,
//   fontStyle: "italic",
// });

// Font.register({
//   family: 'Roboto',
//   fonts: [
//     {
//       src: Roboto,
//       fontWeight: 400
//     },
//     {
//       src: RobotoBold,
//       fontWeight: 700
//     },
//     {
//       src: RobotoItalic,
//       fontWeight: 400,
//       fontStyle: 'italic'
//     },
//     {
//       src: RobotoLight,
//       fontWeight: 300
//     }
//   ]
// })

// Font.register({
//   family: 'Poppins',
//   fonts: [
//     {
//       src: Poppins,
//       fontWeight: 400
//     },
//     {
//       src: PoppinsBold,
//       fontWeight: 700
//     },
//     {
//       src: PoppinsItalic,
//       fontWeight: 400,
//       fontStyle: 'italic'
//     }
//   ]
// })

const styles = StyleSheet.create({
  viewer: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  page: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ffffff",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#082463",
  },
  titlesContainer: {
    display: "flex",
    flexDirection: "row",
    padding: "30px",
  },
  icon: {
    width: "35px",
    height: "35px",
  },
  titles: {
    marginLeft: "8px",
  },
  title: {
    color: "#ffffff",
    fontSize: "18px",
    // fontFamily: 'RobotoLight'
  },
  subtitle: {
    color: "#ffffff",
    fontSize: "13px",
    // fontFamily: 'RobotoBold'
  },
  validation: {
    color: "#dba319",
    fontSize: "10px",
    // fontFamily: 'PoppinsItalic'
    // fontFamily: "RobotoItalic",
  },
  logo: {
    width: "100px",
    height: "100px",
    alignSelf: "center",
    marginLeft: "auto",
    padding: "30px",
  },
  footer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#eef0fc",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  leftSide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "10px",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rightSide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginTop: "10px",
    marginRight: "10px",
    padding: "10px",
  },
  socials: {
    display: "flex",
    flexDirection: "row",
  },
  links: {
    display: "flex",
    flexDirection: "row",
  },
  linkText: {
    color: "#082463",
    fontSize: "10px",
    fontWeight: "500",
    textDecoration: "none",
  },
  linkAdd: {
    color: "#082463",
    fontSize: "10px",
    textDecoration: "none",
    width: "270",
  },
  copyright: {
    textAlign: "center",
    fontSize: "8px",
    // fontWeight: "300",
    color: "#676767",
    marginBottom: "5px",
  },
  image: {
    width: 350,
    height: 300,
  },
  contentBox: {
    borderRadius: 6,
    border: "1px solid #d9d9d9",
    color: "black",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    alignContent: "center",
    gap: "20px",
    margin: "25px 25px 0px 25px",
  },
  contentDf: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    marginBottom: "20px",
  },
  value: {
    color: "#082463",
    marginBottom: "2px",
    fontSize: "15px",
  },
  cardTitle: {
    color: "black",
    fontSize: "13px",
  },
  infosBox: {
    borderRadius: 6,
    border: "1px solid #d9d9d9",
    color: "black",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  contentTitle: {
    color: "#082463",
    fontSize: "20px",
    textAlign: "center",
    marginTop: "20px",
  },
  span: {
    color: "#505050",
    fontSize: "12px",
    alignSelf: "center",
  },
  steps: {
    display: "flex",
    flexDirection: "row",
    margin: "25px 25px 25px 25px",
    gap: "35px",
  },
  stepContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "6px",
    color: "black",
    border: "1px solid #d9d9d9",
  },
  stepAjust: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  stepHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "15px 20px 0px 20px",
  },
  stepIcon: {
    width: 20,
    height: 20,
    marginRight: 8,
  },
  stepTitle: {
    color: "#082463",
    fontSize: "13px",
  },
  stepContent: {
    display: "flex",
    flexDirection: "column",
    padding: "15px 20px 10px 20px",
  },
  stepBox: {
    display: "flex",
    flexDirection: "column",
  },
  stepName: {
    color: "#082463",
    fontSize: "12px",
  },
  stepValue: {
    color: "black",
    fontSize: "12px",
  },
  stepbystep: {
    backgroundColor: "#142365",
    display: "flex",
    flexDirection: "row",
    borderRadius: "6px",
    color: "white",
    justifyContent: "space-around",
    margin: "25px 25px 0px 25px",
  },
  infosStep: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "center",
    textAlign: "center",
    margin: "20px",
  },
  infosStepTitle: {
    fontSize: "15px",
    color: "#e3e7f4",
  },
  infosStepDescription: {
    color: "#e3e7f4",
    fontSize: "12px",
    width: "145px",
  },
  linkIcons: {
    width: "12px",
    height: "12px",
    marginRight: "5px",
  },
  topContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  contentIcon: {
    width: "28px",
    height: "28px",
    marginTop: "20px",
    marginLeft: "5px",
  },
});

function PDFDocument({ data }) {
  const realFormat = {
    minimumFractionDigits: 2,
    style: "currency",
    currency: "BRL",
  };

  const today = new Date();
  var requiredDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 3
  );

  return (
    // <PDFViewer style={styles.viewer}>
    <Document>
      <Page size={"A4"} style={styles.page}>
        <View style={styles.header}>
          <View style={styles.titlesContainer}>
            <Image
              src="https://iili.io/Jf8PnA7.png"
              alt="icon"
              style={styles.icon}
            />
            <View style={styles.titles}>
              <Text style={styles.title}>Guerra Consórcios</Text>
              <Text style={styles.subtitle}>
                Simulação de Consórcio Banco do Brasil
              </Text>
              <Text style={styles.validation}>
                Proposta válida até {requiredDate.toLocaleDateString("pt-BR")}
              </Text>
            </View>
          </View>
          <Image
            src="https://iili.io/JfjDzCv.png"
            alt="logo"
            style={styles.logo}
          />
        </View>
        <View>
          <View style={styles.contentBox}>
            <View>
              <View style={styles.topContent}>
                <Text style={styles.contentTitle}>Credito Simulado</Text>
                <Image
                  src="https://iili.io/J7e1W6x.png"
                  alt="check"
                  style={styles.contentIcon}
                />
              </View>
              <Text style={styles.span}>Veja o resultado</Text>
            </View>
            <View style={styles.infosBox}>
              <Text style={styles.value}>{data.selectedBem.nome}</Text>
              <Text style={styles.cardTitle}>Nome do bem</Text>
            </View>
            <View style={styles.contentDf}>
              <View style={styles.infosBox}>
                <Text style={styles.value}>
                  {(data.credito?.valorBem * data.multiple).toLocaleString("pt-BR", realFormat)}
                </Text>
                <Text style={styles.cardTitle}>Valor do Consórcio</Text>
              </View>
              <View style={styles.infosBox}>
                <Text style={styles.value}>
                  {(data.plano?.grupo?.valorParcela * data.multiple).toLocaleString(
                    "pt-BR",
                    realFormat
                  )}
                </Text>
                <Text style={styles.cardTitle}>Valor da Parcela</Text>
              </View>
              <View style={styles.infosBox}>
                <Text style={styles.value}>
                  {data.plano?.grupo?.quantidadeMesesPrazo}
                </Text>
                <Text style={styles.cardTitle}>Número de Parcelas</Text>
              </View>
            </View>
          </View>
          <View style={styles.stepbystep}>
            <View style={styles.infosStep}>
              <Image
                src="https://iili.io/J7OUcDG.png"
                alt="wire"
                style={styles.icon}
              />
              <Text style={styles.infosStepTitle}>1. Simulação</Text>
              <Text style={styles.infosStepDescription}>
                Os valores da simulação serão a base do seu negócio.
              </Text>
            </View>
            <View style={styles.infosStep}>
              <Image
                src="https://iili.io/J7OUYRn.png"
                alt="handshake"
                style={styles.icon}
              />
              <Text style={styles.infosStepTitle}>2. Fechar o negócio</Text>
              <Text style={styles.infosStepDescription}>
                Receba apoio diretamente dos nossos consultores, de forma
                especializada e exclusiva.
              </Text>
            </View>
            <View style={styles.infosStep}>
              <Image
                src="https://iili.io/J7OUAlI.png"
                alt="box"
                style={styles.icon}
              />
              <Text style={styles.infosStepTitle}>3. Pronto!</Text>
              <Text style={styles.infosStepDescription}>
                Agora é só esperar seu bem ser contemplado.
              </Text>
            </View>
          </View>
          <View style={styles.steps}>
            <View style={styles.stepContainer}>
              <View style={styles.stepAjust}>
                <View style={styles.stepHeader}>
                  <Image
                    alt="step-1"
                    style={styles.stepIcon}
                    src="https://iili.io/Jf8PoN9.png"
                  />
                  <Text style={styles.stepTitle}>Valores Contratados</Text>
                </View>
                <View style={styles.stepContent}>
                  <View style={styles.stepBox}>
                    <Text style={styles.stepName}>Crédito Total</Text>
                    <Text style={styles.stepValue}>
                      {(data.credito?.valorBem * data.multiple).toLocaleString(
                        "pt-BR",
                        realFormat
                      )}
                    </Text>
                  </View>
                  <View style={styles.stepBox}>
                    <Text style={styles.stepName}>
                      Entrada [Parcela Inicial]
                    </Text>
                    <Text style={styles.stepValue}>
                      Sem entrada
                      {/* ${data.vEnt.toLocaleString("pt-BR", realFormat)} */}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={styles.stepContainer}>
              <View style={styles.stepAjust}>
                <View style={styles.stepHeader}>
                  <Image
                    alt="step-2"
                    style={styles.stepIcon}
                    src="https://iili.io/Jf8PIou.png"
                  />
                  <Text style={styles.stepTitle}>Lance</Text>
                </View>
                <View style={styles.stepContent}>
                  <View style={styles.stepBox}>
                    <Text style={styles.stepName}>Lance Embutido</Text>
                    <Text style={styles.stepValue}>
                      {data.plano?.menorLanceContemplacao?.valor.toLocaleString(
                        "pt-BR",
                        realFormat
                      )}
                    </Text>
                  </View>
                  <View style={styles.stepBox}>
                    <Text style={styles.stepName}>Lance Total</Text>
                    <Text style={styles.stepValue}>
                      {data.plano?.menorLanceContemplacao?.valor.toLocaleString(
                        "pt-BR",
                        realFormat
                      )}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={styles.stepContainer}>
              <View style={styles.stepAjust}>
                <View style={styles.stepHeader}>
                  <Image
                    alt="step-3"
                    style={styles.stepIcon}
                    src="https://iili.io/Jf8P5cQ.png"
                  />
                  <Text style={styles.stepTitle}>Taxas</Text>
                </View>
                <View style={styles.stepContent}>
                  <View style={styles.stepBox}>
                    <Text style={styles.stepName}>Taxa de Administração</Text>
                    <Text style={styles.stepValue}>
                      {data.plano?.taxaAdministracao?.percentual}%
                    </Text>
                  </View>
                  <View style={styles.stepBox}>
                    <Text style={styles.stepName}>Percentual Mensal</Text>
                    <Text style={styles.stepValue}>
                      {data.plano?.taxaAdministracao?.percentualMensal}%
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
        <View style={styles.footer}>
          <View style={styles.contentContainer}>
            <View style={styles.leftSide}>
              <View style={styles.links}>
                <Image
                  src="https://iili.io/J7Obn2a.png"
                  alt="maps"
                  style={styles.linkIcons}
                />
                <Link
                  src="https://maps.app.goo.gl/Ns7Ngw1BVXSxYCBB7"
                  style={styles.linkAdd}
                >
                  SCS QUADRA 01 BLOCO E LOTE 30 LOJAS 04 E 05 - Asa Sul,
                  Brasília - DF, 70303-900, Brasil.
                </Link>
              </View>
              <View style={styles.links}>
                <Image
                  src="https://iili.io/J7OboYJ.png"
                  alt="phone"
                  style={styles.linkIcons}
                />
                <Link src="tel:+556130815555" style={styles.linkAdd}>
                  +55 (61) 3081-5555
                </Link>
              </View>
            </View>
            <View style={styles.rightSide}>
              <View style={styles.socials}>
                <Link
                  src="https://www.linkedin.com/company/guerra-finan%C3%A7as-&-neg%C3%B3cios/posts/"
                  style={styles.linkText}
                >
                  <Image
                    src="https://iili.io/J7ObBrg.png"
                    alt="linkedin"
                    style={styles.linkIcons}
                  />
                </Link>
                <Text> </Text>
                <Link
                  src="https://www.instagram.com/guerraconsorcios/"
                  style={styles.linkText}
                >
                  <Image
                    src="https://iili.io/J7ObqEF.png"
                    alt="insta"
                    style={styles.linkIcons}
                  />
                </Link>
                <Text> </Text>
                <Link src="https://wa.me/+556130815555" style={styles.linkText}>
                  <Image
                    src="https://iili.io/J7e1VGj.png"
                    alt="whats"
                    style={styles.linkIcons}
                  />
                </Link>
              </View>
              <View style={styles.links}>
                <Link
                  src="https://digital.guerraconsorcios.com.br/simulador/AU"
                  style={styles.linkText}
                >
                  Simulador
                </Link>
                <Text> </Text>
                <Text style={styles.linkText}> | </Text>
                <Link
                  src="https://www.guerraconsorcios.com.br/"
                  style={styles.linkText}
                >
                  Site
                </Link>
                <Text> </Text>
                <Text style={styles.linkText}> | </Text>
                <Link
                  src="https://www.guerraconsorcios.com.br/contato/"
                  style={styles.linkText}
                >
                  Contato
                </Link>
              </View>
            </View>
          </View>
          {/* <View>
            <Text style={styles.copyright}>
              © Guerra Consórcios. Todos os Direitos Reservados.
            </Text>
          </View> */}
        </View>
      </Page>
    </Document>
    // </PDFViewer>
  );
}
export default PDFDocument;
